import { render, staticRenderFns } from "./deleteAttendanceClasses.vue?vue&type=template&id=24d80427&scoped=true"
import script from "./deleteAttendanceClasses.vue?vue&type=script&lang=js"
export * from "./deleteAttendanceClasses.vue?vue&type=script&lang=js"
import style0 from "./deleteAttendanceClasses.vue?vue&type=style&index=0&id=24d80427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d80427",
  null
  
)

export default component.exports